let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("jPS1u"), load("ijHdC"), load("lDQ7w"), load("dIKKx")]).then(() => parcelRequire('eYRFW'));